import { Loading } from 'components/Loading';

export function LayoutFallback() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-200 p-14">
      <Loading hideText size="large" />
    </div>
  );
}
